import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitSupportRequestMutationVariables = Types.Exact<{
  kind: Types.Scalars['String']['input'];
  issue_type?: Types.InputMaybe<Types.Scalars['String']['input']>;
  message: Types.Scalars['String']['input'];
}>;


export type SubmitSupportRequestMutation = { __typename?: 'mutation_root', submit_support_request?: { __typename?: 'SubmitSupportRequestOutput', success: boolean } | null };


export const SubmitSupportRequestDocument = gql`
    mutation submitSupportRequest($kind: String!, $issue_type: String, $message: String!) {
  submit_support_request(kind: $kind, issue_type: $issue_type, message: $message) {
    success
  }
}
    `;
export type SubmitSupportRequestMutationFn = Apollo.MutationFunction<SubmitSupportRequestMutation, SubmitSupportRequestMutationVariables>;

/**
 * __useSubmitSupportRequestMutation__
 *
 * To run a mutation, you first call `useSubmitSupportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSupportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSupportRequestMutation, { data, loading, error }] = useSubmitSupportRequestMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      issue_type: // value for 'issue_type'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSubmitSupportRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSupportRequestMutation, SubmitSupportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSupportRequestMutation, SubmitSupportRequestMutationVariables>(SubmitSupportRequestDocument, options);
      }
export type SubmitSupportRequestMutationHookResult = ReturnType<typeof useSubmitSupportRequestMutation>;
export type SubmitSupportRequestMutationResult = Apollo.MutationResult<SubmitSupportRequestMutation>;
export type SubmitSupportRequestMutationOptions = Apollo.BaseMutationOptions<SubmitSupportRequestMutation, SubmitSupportRequestMutationVariables>;